// Explicit registry of the Lucide icons this site uses, keyed by the design
// system's kebab-case names (matching the original `data-lucide="…"` markup).
// Importing only what we need keeps Lucide out of the vendor bundle wholesale.
import {
  PawPrint, Mountain, Landmark, Leaf, Palmtree, Fish, Gem, UtensilsCrossed,
  Church, Briefcase, MapPin, Phone, Mail, Globe, Calendar, Clock, Sparkles,
  Gauge, Star, Footprints, Cat, Wind, Eye, Users, Route, Tent, Sunrise, Waves,
  Trees, Bird, Droplets, Flame, Store, Coffee, Palette, Search, Facebook,
  Twitter, Link, ChevronDown, Check, X, Camera, MessageCircle, CloudSun,
  ArrowRight, ArrowLeft, Globe2, Compass, Sun, Shield, BookOpen, Plane,
  Instagram, Send, Minus, Plus, AlertCircle,
} from 'lucide-vue-next';

export const ICONS = {
  'paw-print': PawPrint,
  mountain: Mountain,
  landmark: Landmark,
  leaf: Leaf,
  palmtree: Palmtree,
  fish: Fish,
  gem: Gem,
  'utensils-crossed': UtensilsCrossed,
  church: Church,
  briefcase: Briefcase,
  'map-pin': MapPin,
  phone: Phone,
  mail: Mail,
  globe: Globe,
  calendar: Calendar,
  clock: Clock,
  sparkles: Sparkles,
  gauge: Gauge,
  star: Star,
  footprints: Footprints,
  cat: Cat,
  wind: Wind,
  eye: Eye,
  users: Users,
  route: Route,
  tent: Tent,
  sunrise: Sunrise,
  waves: Waves,
  trees: Trees,
  bird: Bird,
  droplets: Droplets,
  flame: Flame,
  store: Store,
  coffee: Coffee,
  palette: Palette,
  search: Search,
  facebook: Facebook,
  twitter: Twitter,
  link: Link,
  'chevron-down': ChevronDown,
  check: Check,
  x: X,
  camera: Camera,
  'message-circle': MessageCircle,
  'cloud-sun': CloudSun,
  'arrow-right': ArrowRight,
  'arrow-left': ArrowLeft,
  'globe-2': Globe2,
  compass: Compass,
  sun: Sun,
  shield: Shield,
  book: BookOpen,
  plane: Plane,
  instagram: Instagram,
  send: Send,
  minus: Minus,
  plus: Plus,
  'alert-circle': AlertCircle,
};

export default ICONS;
